<template>
    <div id="app">
        <router-view></router-view>
        <back-top></back-top>
    </div>
</template>

<script>
    import {setMenuId, getSessionToken, getToken, setToken} from '@/utils/auth'
    import Vue from 'vue'
    import store from './store'
    import {Message} from "element-ui";

    export default {
        name: 'app',
        watch: {
            '$route': {
                immediate: true,
                deep: true,
                handler(to, from) {
                    try {
                        let hash = to.path;
                        let resMenus = this.$store.state.permission.resMenus;
                        let menu = resMenus.find(v => hash == v.url);
                        if (menu) {
                            setMenuId(menu.id)
                        }
                    } catch (e) {

                    }
                }
            }
        },
        beforeCreate() {
            if (document.hidden !== undefined) {
                document.addEventListener('visibilitychange', () => {
                    let sessionToken = getSessionToken();
                    let token = getToken();
                    if (sessionToken != token) {
                        store.dispatch('getMenus').then(res => {
                            location.reload();
                        }).catch((e) => {
                            store.dispatch('logOut').then(() => {
                                Message.error('验证失败,请重新登录')
                                next({path: '/login'})
                            })
                        })
                        setToken(token)
                    }
                })
            }
            this.$fetchData(this.$api.fwReportConfig.active).then(res => {
                if (res) {
                    Vue.prototype.$envFR = res.active
                }
            })
        }
    }
</script>
